import React, { useContext } from 'react';
import c from 'classnames';
import CommentBox from '../../../CommentBox/presets/CommentBox';
import { CommentContext } from '../../CommentContext';
import { useReplyCommentBoxBase } from './useReplyCommentBoxBase';
import s from './ReplyCommentBox.scss';
/** Our `CommentBox` with some comment specific props passed through. */
var ReplyCommentBox = function (_a) {
    var canPostComment = _a.canPostComment, className = _a.className, nc = _a.nc, onReplyPosted = _a.onReplyPosted;
    var _b = useReplyCommentBoxBase({
        onPublishSuccess: onReplyPosted,
    }), id = _b.id, onCancel = _b.onCancel, onPublishSuccess = _b.onPublishSuccess;
    var comment = useContext(CommentContext).comment;
    return (React.createElement(CommentBox, { id: id, className: c(s['root'], className), commentableType: comment.typeId, commentableItemId: comment.itemId, replyComment: comment, autoFocus: true, canPostComment: !!canPostComment, nc: nc, onPublishSuccess: onPublishSuccess, onClose: onCancel }));
};
ReplyCommentBox.displayName = 'ReplyCommentBox';
export default ReplyCommentBox;
//# sourceMappingURL=ReplyCommentBox.js.map